import { cn } from '@lib/utils';
import type { CSSProperties } from 'react';


export type SparkleColor = 'green' | 'purple' | 'blue' | 'amber' | 'pink';
export type SparkleSize = 'sm' | 'md' | 'lg' | 'xl';

const COLOR: Record<SparkleColor, string> = {
  green: 'bg-gradient-to-br from-emerald-300 via-teal-400 to-emerald-500',
  purple: 'bg-gradient-to-br from-fuchsia-300 via-purple-400 to-indigo-500',
  blue: 'bg-gradient-to-br from-sky-300 via-blue-400 to-indigo-400',
  amber: 'bg-gradient-to-br from-yellow-300 via-amber-400 to-orange-400',
  pink: 'bg-gradient-to-br from-pink-300 via-rose-400 to-fuchsia-400',
};

const SIZE: Record<SparkleSize, string> = {
  sm: 'h-24 w-24',
  md: 'h-40 w-40',
  lg: 'h-64 w-64',
  xl: 'h-96 w-96',
};

export interface SparkleOrbProps {
  color?: SparkleColor;
  size?: SparkleSize;
  className?: string;
  style?: CSSProperties;
}

/** Decorative blurred gradient orb. Always absolute, always pointer-events-none. */
export function SparkleOrb({
  color = 'green',
  size = 'md',
  className,
  style,
}: SparkleOrbProps): JSX.Element {
  return (
    <div
      aria-hidden
      style={style}
      className={cn(
        'pointer-events-none absolute rounded-full opacity-40 blur-3xl',
        COLOR[color],
        SIZE[size],
        className,
      )}
    />
  );
}
